import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import logs from './utils/logs'
import formErros from './modules/formErros'
import checkbox from './modules/checkbox'

UseMouseOrKeyboard()
formErros()
PageLogin()?.init()
logs()
checkbox()?.init()


document.addEventListener('DOMContentLoaded', () => {
    function hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    (() => {
        const hexValue = getComputedStyle(document.body).getPropertyValue('--primary')
        if (!hexValue) return
        const { r, g, b } = hexToRgb(hexValue)

        document.body.style.setProperty('--primary-pure', `${r}, ${g}, ${b}`);
    })()


})